type Channel = 'email' | 'sms'

export const loginTranslations = {
  en: {
    title: 'Sign in to Finley',
    intro: 'Use the same email or phone number as the app.',
    codeSent: (channel: Channel) => `We sent a code to your ${channel === 'sms' ? 'phone' : 'email'}.`,
    channelEmail: 'Email',
    emailPlaceholder: 'you@example.com',
    channelPhone: 'Phone',
    sending: 'Sending…',
    sendCode: 'Send code',
    verifying: 'Verifying…',
    verify: 'Verify & continue',
    changeIdentifier: 'Use a different email or phone',
    errorSend: 'Could not send a code. Please check your details and try again.',
    errorSignupRequired: 'No Finley account for this yet — sign up in the app first, then come back.',
    errorInvalidCode: 'That code was invalid or expired. Please try again.',
  },
  de: {
    title: 'Bei Finley anmelden',
    intro: 'Nutze dieselbe E-Mail-Adresse oder Telefonnummer wie in der App.',
    codeSent: (channel: Channel) =>
      `Wir haben dir einen Code per ${channel === 'sms' ? 'SMS' : 'E-Mail'} geschickt.`,
    channelEmail: 'E-Mail',
    emailPlaceholder: 'du@beispiel.de',
    channelPhone: 'Telefon',
    sending: 'Wird gesendet…',
    sendCode: 'Code senden',
    verifying: 'Wird geprüft…',
    verify: 'Bestätigen & weiter',
    changeIdentifier: 'Andere E-Mail-Adresse oder Telefonnummer verwenden',
    errorSend: 'Wir konnten keinen Code senden. Bitte prüfe deine Angaben und versuche es erneut.',
    errorSignupRequired: 'Zu diesen Angaben gibt es noch kein Finley-Konto — registriere dich zuerst in der App und komm dann zurück.',
    errorInvalidCode: 'Der Code ist ungültig oder abgelaufen. Bitte versuche es erneut.',
  },
} as const

export type LoginLocale = keyof typeof loginTranslations
export const loginT = (locale: string) => loginTranslations[locale as LoginLocale] || loginTranslations.en
